import { render, staticRenderFns } from "./EmailCancellationView.vue?vue&type=template&id=33ef4004&scoped=true&"
import script from "./EmailCancellationView.vue?vue&type=script&lang=js&"
export * from "./EmailCancellationView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33ef4004",
  null
  
)

export default component.exports